<ion-menu content-id="main" side="start">
  <ion-content>
    @if (!isCompiler()) {
      <ion-item matRipple (click)="navigate('/home')" lines="full">
        <h6 class="v-center">{{ "home.title" | transloco }}</h6>
        <ion-avatar slot="end">
          <svg
            id="svg-home"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              d="M80 212v236a16 16 0 0016 16h96V328a24 24 0 0124-24h80a24 24 0 0124 24v136h96a16 16 0 0016-16V212"
            />
            <path
              d="M480 256L266.89 52c-5-5.28-16.69-5.34-21.78 0L32 256M400 179V64h-48v69"
            />
          </svg>
        </ion-avatar>
      </ion-item>
    }

    @if (isAdministrator()) {
      <ion-item
        (click)="navigate('/user-manager')"
        matRipple
        detail="false"
        lines="full"
      >
        <h6 class="v-center">{{ "userManager.title" | transloco }}</h6>
        <ion-avatar slot="end">
          <svg
            version="1.1"
            id="Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 500 500"
            style="enable-background: new 0 0 500 500"
            xml:space="preserve"
          >
            <g>
              <path
                d="M389.5,211.2c23.3-0.1,42.2-18.9,42.3-42.3c0-23.3-18.9-42.3-42.3-42.3s-42.3,18.9-42.3,42.3S366.2,211.2,389.5,211.2z
		 M389.5,147.8c12.7,0,21.1,8.5,21.1,21.1s-8.5,21.1-21.1,21.1c-12.7,0-21.1-8.5-21.1-21.1S376.8,147.8,389.5,147.8z"
              />
              <path
                d="M421.2,232.3h-63.4c-6.3,0-10.6,4.2-10.6,10.6s4.2,10.6,10.6,10.6h63.4c16.9,0,31.7,14.8,31.7,31.7v53.9
		c0,6.3,4.2,10.6,10.6,10.6c6.3,0,10.6-4.2,10.6-10.6v-53.9c0-0.3,0-0.7,0-1C473.7,255.2,450.1,232,421.2,232.3z"
              />
              <path
                d="M110.5,211.2c23.3-0.1,42.2-18.9,42.3-42.3c0-23.3-18.9-42.3-42.3-42.3s-42.3,18.9-42.3,42.3S87.2,211.2,110.5,211.2z
		 M110.5,147.8c12.7,0,21.1,8.5,21.1,21.1s-8.5,21.1-21.1,21.1c-12.7,0-21.1-8.5-21.1-21.1S97.8,147.8,110.5,147.8z"
              />
              <path
                d="M152.8,242.9c0-6.3-4.2-10.6-10.6-10.6H78.8c-0.3,0-0.7,0-1,0c-28.9,0.3-52.1,23.9-51.8,52.8v47.4
		c0,6.3,4.2,10.6,10.6,10.6c6.3,0,10.6-4.2,10.6-10.6v-47.4c0-16.9,14.8-31.7,31.7-31.7h63.4C148.5,253.5,152.8,249.2,152.8,242.9z"
              />
              <path
                d="M250,221.8c35.9,0,63.4-27.5,63.4-63.4c0-35.9-27.5-63.4-63.4-63.4s-63.4,27.5-63.4,63.4S214.1,221.8,250,221.8z
		 M250,116.1c23.3,0.1,42.2,18.9,42.3,42.3c0,23.3-18.9,42.3-42.3,42.3s-42.3-18.9-42.3-42.3S226.7,116.1,250,116.1z"
              />
              <path
                d="M313.4,253.5H186.6c-0.3,0-0.7,0-1,0c-28.9,0.3-52.1,23.9-51.8,52.8v88.2c0,6.3,4.2,10.6,10.6,10.6s10.6-4.2,10.6-10.6
		v-88.2c0-16.9,14.8-31.7,31.7-31.7h126.8c16.9,0,31.7,14.8,31.7,31.7v88.2c0,6.3,4.2,10.6,10.6,10.6c6.3,0,10.6-4.2,10.6-10.6
		v-88.2c0-0.3,0-0.7,0-1C365.9,276.3,342.3,253.2,313.4,253.5z"
              />
            </g>
          </svg>
        </ion-avatar>
      </ion-item>
    }

    <ion-item
      (click)="navigate('/budgets/list' + (isCompiler() ? '-compiler' : ''))"
      matRipple
      detail="false"
      lines="full"
    >
      <h6 class="v-center">{{ "budgets.management.title" | transloco }}</h6>
      <ion-avatar slot="end">
        <svg
          version="1.1"
          id="Livello_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 500 500"
          style="enable-background: new 0 0 500 500"
          xml:space="preserve"
        >
          <g>
            <path
              d="M284.8,99.8H112.3c-6.4,0-11.5,5.1-11.5,11.5s5.1,11.5,11.5,11.5h172.5c6.4,0,11.5-5.1,11.5-11.5S291.1,99.8,284.8,99.8z"
            />
            <path
              d="M478.1,380.6c-0.1-0.1-0.1-0.1-0.2-0.2l-21.4-16.8c0.2-2.5,0.3-4.9,0.3-7.4c0,0,0,0,0-0.1c0-2.3-0.1-4.7-0.3-7.6l21.4-16.8
		c0.1-0.1,0.1-0.1,0.2-0.2c6.1-5.1,7.7-13.7,3.7-20.6L457.4,269c0,0,0-0.1-0.1-0.1c-4-6.8-12.3-9.6-19.6-6.8c-0.1,0-0.1,0-0.2,0.1
		l-25.2,10.1c-4.1-2.8-8.4-5.3-12.9-7.5l-3.8-26.8c0-0.2-0.1-0.4-0.1-0.6c-1.6-7.6-8-12.9-15.7-13c-0.1,0-0.1,0-0.2,0H331
		c-0.1,0-0.1,0-0.2,0c-7.8,0.2-14.4,5.8-15.7,13.5c0,0.1,0,0.2-0.1,0.3l-3.8,26.8c-4.4,2.2-8.7,4.7-12.8,7.5l-25.2-10.1
		c-0.1,0-0.1,0-0.2-0.1c-7.4-2.8-15.6,0.1-19.6,6.9c0,0,0,0.1-0.1,0.1l-24.3,42c-3.9,6.8-2.4,15.4,3.5,20.5c0.1,0.1,0.2,0.2,0.3,0.2
		l21.4,16.8c-0.2,2.6-0.3,5-0.3,7.4s0.1,4.8,0.3,7.6l-21.4,16.8c-0.1,0.1-0.1,0.1-0.2,0.2c-6.1,5.1-7.7,13.7-3.7,20.6l24.4,42.2
		c0,0,0,0.1,0.1,0.1c4,6.8,12.3,9.7,19.6,6.9c0.1,0,0.1,0,0.2-0.1l25.2-10.1c4.1,2.8,8.4,5.3,12.9,7.5l3.8,26.8
		c0,0.2,0.1,0.4,0.1,0.6c1.6,7.6,8,12.9,15.7,13c0.1,0,0.1,0,0.2,0h48.8c0.1,0,0.1,0,0.2,0c7.8-0.2,14.4-5.8,15.7-13.5
		c0-0.1,0-0.2,0.1-0.3l3.8-26.8c4.4-2.2,8.7-4.7,12.8-7.5l25.2,10.1c0.1,0,0.1,0,0.2,0.1c7.4,2.8,15.6-0.1,19.7-6.9
		c0,0,0-0.1,0.1-0.1l24.4-42.2C485.8,394.3,484.2,385.7,478.1,380.6z M441.8,430.4l-22.4-9c-6-2.4-12.8-1.6-18,2.1
		c-3.5,2.4-7.2,4.5-11,6.4c-5.7,2.8-9.7,8.2-10.6,14.5l-3.4,23.9h-42.1l-3.3-23.8c-0.9-6.4-4.9-11.8-10.7-14.5
		c-3.8-1.8-7.4-4-10.9-6.4c-5.3-3.7-12.1-4.5-18.1-2l-22.4,9l-21-36.4l19.1-15c5.1-4,7.8-10.3,7.2-16.7c-0.2-2.3-0.3-4.3-0.3-6.3
		s0.1-4,0.3-6.2c0.5-6.4-2.2-12.7-7.2-16.7l-19-14.9l21-36.4l22.4,9c6,2.4,12.8,1.6,18-2.1c3.5-2.4,7.2-4.5,11-6.4
		c5.7-2.8,9.7-8.2,10.6-14.5l3.4-23.9h42.1l3.3,23.8c0.9,6.4,4.9,11.8,10.7,14.5c3.8,1.8,7.4,4,10.9,6.4c5.3,3.7,12.1,4.5,18.1,2
		l22.4-9l21,36.4l-19.1,15c-5.1,4-7.8,10.3-7.2,16.7c0.2,2.4,0.3,4.4,0.3,6.2c0,3.5-0.3,7-0.8,10.5s0.9,7.1,3.7,9.3l23,18.1
		L441.8,430.4z"
            />
            <g>
              <path
                d="M112.3,272.3c-6.4,0-11.5,5.1-11.5,11.5c0,6.4,5.1,11.5,11.5,11.5h86.3c6.4,0,11.5-5.1,11.5-11.5
			c0-6.4-5.1-11.5-11.5-11.5H112.3z"
              />
              <path
                d="M296.3,197.5c0-6.4-5.1-11.5-11.5-11.5H112.3c-6.4,0-11.5,5.1-11.5,11.5c0,6.4,5.1,11.5,11.5,11.5h172.5
			C291.1,209,296.3,203.9,296.3,197.5z"
              />
              <path
                d="M401.7,348.6c-2.2-21.9-19.8-39.4-41.7-41.6c-12.4-1.2-24.5,2.4-34.1,10.3c-9.6,7.9-15.6,19-16.8,31.4
			c-2.5,25.5,16.2,48.3,41.7,50.8c1.6,0.2,3.1,0.2,4.7,0.2c10.7,0,21-3.7,29.4-10.6c9.6-7.9,15.6-19,16.8-31.4
			C402,354.7,402,351.6,401.7,348.6z M381.8,355.9c-0.7,7-4.1,13.4-9.6,17.9s-12.4,6.6-19.4,5.9c-14.5-1.4-25.2-14.4-23.8-29
			c0.7-7,4.1-13.4,9.6-17.9c4.8-3.9,10.6-6,16.8-6c0.9,0,1.8,0,2.7,0.1c12.5,1.2,22.5,11.2,23.8,23.8
			C381.9,352.4,381.9,354.1,381.8,355.9z"
              />
              <path
                d="M37.5,425.6V73c0-20.1,16.4-36.5,36.5-36.5h249.1c20.1,0,36.5,16.4,36.5,36.5v152h23V73c0-32.8-26.7-59.5-59.5-59.5H74
			c-32.8,0-59.5,26.7-59.5,59.5v352.6c0,32.8,26.7,59.5,59.5,59.5h248v-23H74C53.9,462.1,37.5,445.7,37.5,425.6z"
              />
            </g>
          </g>
        </svg>
      </ion-avatar>
    </ion-item>

    @if (isAdministrator() || isRoleManager()) {
      <ion-item
        (click)="navigate('/budgets/request')"
        matRipple
        detail="false"
        lines="full"
      >
        <h6 class="v-center">{{ "budgets.creator.title" | transloco }}</h6>
        <ion-avatar slot="end">
          <svg
            version="1.1"
            id="Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 500 500"
            style="enable-background: new 0 0 500 500"
            xml:space="preserve"
          >
            <g>
              <path
                d="M112.9,209.4h173.9c6.4,0,11.5-5.1,11.5-11.5s-5.1-11.5-11.5-11.5H112.9c-6.4,0-11.5,5.1-11.5,11.5
		S106.6,209.4,112.9,209.4z"
              />
              <path
                d="M112.9,122.4h173.9c6.4,0,11.5-5.1,11.5-11.5s-5.1-11.5-11.5-11.5H112.9c-6.4,0-11.5,5.1-11.5,11.5
		S106.6,122.4,112.9,122.4z"
              />
              <path
                d="M199.9,273.3h-86.9c-6.4,0-11.5,5.1-11.5,11.5s5.1,11.5,11.5,11.5h86.9c6.4,0,11.5-5.1,11.5-11.5S206.2,273.3,199.9,273.3z
		"
              />
              <path
                d="M461.5,214.4C461.5,214.4,461.5,214.4,461.5,214.4c-16.7-16.7-43.7-16.7-60.4,0c0,0,0,0,0,0l-15.8,15.8V72
		c0-32.8-26.7-59.5-59.5-59.5H74c-32.8,0-59.5,26.7-59.5,59.5v356.1c0,32.8,26.7,59.5,59.5,59.5h251.8c32.8,0,59.5-26.7,59.5-59.5
		V351l76.2-76.2C478.2,258.1,478.2,231.1,461.5,214.4z M362.3,428.1c0,20.1-16.4,36.5-36.5,36.5H74c-20.1,0-36.5-16.4-36.5-36.5V72
		c0-20.1,16.4-36.5,36.5-36.5h251.8c20.1,0,36.5,16.4,36.5,36.5v181.2L254.2,361.3c-1.2,1.2-2.1,2.7-2.7,4.4l-22.3,66.9
		c-1.9,5.8,1.2,12.2,7.1,14.1c1.1,0.4,2.3,0.6,3.5,0.6c1.2,0,2.4-0.2,3.5-0.6l66.9-22.3c1.6-0.5,3.1-1.5,4.4-2.7l47.7-47.7V428.1z
		 M446,258.8c-0.1,0.1-0.2,0.2-0.2,0.2v0l-145,145l-43.3,14.5l14.4-43.3l145.1-145c7.9-8,20.8-8.2,28.8-0.3
		C453.7,237.8,453.8,250.7,446,258.8z"
              />
            </g>
          </svg>
        </ion-avatar>
      </ion-item>
    }

    @if (isAdministrator()) {
      <ion-item
        (click)="navigate('/budgets/history')"
        matRipple
        detail="false"
        lines="full"
      >
        <h6 class="v-center">{{ "budgets.history.title" | transloco }}</h6>
        <ion-avatar slot="end">
          <svg
            version="1.1"
            id="Livello_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 500 500"
            style="enable-background: new 0 0 500 500"
            xml:space="preserve"
          >
            <g>
              <path
                d="M113,119.5h174c6.4,0,11.5-5.1,11.5-11.5s-5.2-11.5-11.5-11.5H113c-6.4,0-11.5,5.1-11.5,11.5S106.6,119.5,113,119.5z"
              />
              <path
                d="M200,270.5h-87c-6.4,0-11.5,5.1-11.5,11.5c0,6.4,5.1,11.5,11.5,11.5h87c6.4,0,11.5-5.1,11.5-11.5
		C211.5,275.6,206.4,270.5,200,270.5z"
              />
              <path
                d="M113,206.5h174c6.3,0,11.5-5.2,11.5-11.5c0-6.4-5.1-11.5-11.5-11.5H113c-6.4,0-11.5,5.1-11.5,11.5
		C101.5,201.4,106.6,206.5,113,206.5z"
              />
              <path
                d="M385.5,234.4V69c0-32.8-26.7-59.5-59.5-59.5H74C41.2,9.5,14.5,36.2,14.5,69v356.3c0,32.8,26.7,59.5,59.5,59.5h242V484
		c12.1,3.8,25,5.8,38.4,5.8c34.6,0,67.2-13.5,91.6-38c24.5-24.5,38-57,38-91.7C484,299.5,442,248.4,385.5,234.4z M74,461.8
		c-20.1,0-36.5-16.3-36.5-36.5V69c0-20.1,16.4-36.5,36.5-36.5h252c20.1,0,36.5,16.4,36.5,36.5v161.9c-2.7-0.2-5.4-0.3-8.1-0.3
		c-71.5,0-129.6,58.1-129.6,129.6c0,41.1,19.2,77.8,49.2,101.6H74z M431.9,437.8c-20.7,20.7-48.2,32.1-77.5,32.1
		c-13.5,0-26.4-2.5-38.4-7v-1.1h-2.9c-40-16.4-68.3-55.7-68.3-101.5c0-60.4,49.2-109.6,109.6-109.6c60.4,0,109.6,49.2,109.6,109.6
		C464,389.5,452.6,417.1,431.9,437.8z"
              />
              <path
                d="M414.2,360.2h-49.8v-79.7c0-5.5-4.5-10-10-10s-10,4.5-10,10v89.7c0,5.5,4.5,10,10,10h59.8c5.5,0,10-4.5,10-10
		S419.7,360.2,414.2,360.2z"
              />
            </g>
          </svg>
        </ion-avatar>
      </ion-item>
    }

    <ion-item (click)="logout()" matRipple lines="full">
      <h6 class="v-center">{{ "logout" | transloco }}</h6>
      <ion-avatar slot="end">
        <svg
          height="19.962"
          viewBox="0 0 25.5 19.962"
          width="25.5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="translate(-47.25 -95.25)">
            <path
              class="a"
              d="M63.692,100.615V98.308A2.308,2.308,0,0,0,61.385,96H50.308A2.308,2.308,0,0,0,48,98.308v13.846a2.308,2.308,0,0,0,2.308,2.308H61.385a2.308,2.308,0,0,0,2.308-2.308v-2.308"
            />
            <path
              class="a"
              d="M384,176l4.615,4.615L384,185.231"
              transform="translate(-316.615 -75.385)"
            />
            <line class="a" transform="translate(56.25 105.231)" x2="15.75" />
          </g>
        </svg>
      </ion-avatar>
    </ion-item>

    <ion-item lines="none" class="version">
      <h6>v. {{ appVersion }}</h6>
    </ion-item>
  </ion-content>
</ion-menu>
